<template>
  <div
    v-if="!isBorrower && currentState && isKyc"
   class="animate-pulse bg-white rounded-2xl w-full flex flex-col justify-between p-4"
  >
    <onboarding-progress-bar
      :current="currentStep"
      :goal="6"
      class="mb-5"
    />
    <div class="flex justify-between">
      <div class="flex">
        <div class="flex items-start w-8 mr-1">
          <img class="w-full" src="@/assets/svg/info.svg" alt="info" />
        </div>
        <div>
          <p class="text-left text-grey-2 text-sm font-semibold mb-2">
            {{ $t('settings.suitability.' + currentState.key + '.title', { category: categoryLabel }) }}
          </p>
          <p class="text-left text-grey-2 text-sm text-opacity-50"
            v-html="$t('settings.suitability.' + currentState.key + '.description', { category: categoryLabel })"
          ></p>
        </div>
      </div>
    </div>
    <router-link
      v-if="currentState.link"
      :to="currentState.link"
      @click="clearCompletion"
      class="orange-link text-right text-13 text-transform: uppercase">
      {{ $t('settings.suitability.' + currentState.key + '.link') }}
    </router-link>
    <button
      v-else
      @click="openLendWarning"
      class="orange-link text-right text-13 uppercase">
      {{ $t('settings.suitability.' + currentState.key + '.action') }}
    </button>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import OnboardingProgressBar from '@/components/general/OnboardingProgressBar.vue'
import { useI18n } from 'vue-i18n'

export default {
  components:{OnboardingProgressBar},
  setup() {
    const store = useStore()
    const justCompleted = computed(() => store.state.general.justSignedLendAck)
    const profile = computed(() => {
      return store.getters.getProfile()
    })

    const { t } = useI18n()

    const isBorrower = computed(() => {
      return (profile.value && profile.value.sub_type === 'borrower') ? true : false
    })

    const isKyc = computed(() =>{
      return profile.value.kyc_level === 'regular' ? true : false
    })

        const investorCategory = computed(() => {
      const subType = profile.value?.sub_type
      if (subType === 'unsuitable_pending') return 'unsuitable_pending'
      if (subType === 'accredited_pending' || subType === 'eligible_pending') return 'pending'
      return 'retail'
    })

    const categoryLabel = computed(() => {
      const subType = profile.value?.sub_type
      const key = ['accredited_pending', 'eligible_pending', 'unsuitable_pending'].includes(subType)
        ? subType
        : 'retail'
      return t(`settings.suitability.sub_types.${key}`)
    })

    const states = computed(() => [
      { key: 'missing', condition: profile.value.suitability.risk_level == null, link: '/suitability' },
      { key: 'incomplete', condition: profile.value.suitability.assets_value == 0, link: '/investor-classification' },
      { key: 'unsuitable', condition: profile.value.sub_type == 'unsuitable_pending', link: '/settings/suitability' },
      { key: 'unsigned', condition: !profile.value.lend_ack },
      { 
        key: `complete.${investorCategory.value}`, 
        condition: justCompleted.value, 
        link: investorCategory.value === 'unsuitable_pending' ? null : '/projects'
      }
    ])

    const currentState = computed(() => {
      return states.value.find(state => state.condition)
    })

    const currentStep = computed(() => {
      if (justCompleted.value) return 6
      return profile.value.suitability.risk_level == null ? 3 : 
        profile.value.suitability.assets_value == 0 ? 4 : 
        (profile.value.sub_type == 'unsuitable_pending' || !profile.value.lend_ack) ? 5 : 6 
    })

    const clearCompletion = () => {
      store.dispatch('setJustSignedLendAck', false)
    }

    const openLendWarning = () => {
      const popup = {
        align: 'left',
        side: false,
        component: 'LendWarning',
        docFormat: true,
        disableClose: true,
        bgColor: 'gp-background',
        props: { profile: profile.value }
      }
      store.dispatch('setPopup', popup)
    }

    return {
      isBorrower,
      isKyc,
      currentState,
      currentStep,
      categoryLabel,
      justCompleted,
      openLendWarning,
      clearCompletion
    }
  }
}
</script>
